import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getCompareMode, getCurrentSummaryData, getSummaryKpiSelected, getTableLoading } from "../../selectors";
import Arrow from "../../components/GraphViews/Arrow";

import Doughnut from "./../../containers/summary/Global/Doughnut";
import { Spin } from "antd";
import { toUnit } from "../../summary/format";

const NBPDCIndicator = (props) => {
  return !props.loading &&
    props.data &&
    props.data.additionalValues &&
    props.data.additionalValues.pdc_count &&
    props.data.additionalValues.pdc_count.hasOwnProperty("v") ? (
    <div
      className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s"
      style={{ marginTop: 10, fontSize: 12, fontWeight:"normal" }}
    >{`Nombre de PDCs : ${props.data.additionalValues.pdc_count.v || 0}`}</div>
  ) : null;
};
const KpiIndicator = props => {
  const kpi = props.kpi || {};
  const data = props.data || {};
  const isComparing = props.isComparing;
  let value = isComparing && data.diff ? data.diff.valueStr : (data && data.valueStr) || "-";

  if (props.loading) {
    value = "-";
  }
  return (
    <Fragment>
      {isComparing ? (
        <Fragment>
          <div style={{ display: "flex", width: "100%", justifyContent: "space-around", height: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around"
              }}
            >
              <span className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s" style={{ fontSize: 20 }}>
                {"Gain "}
                {kpi.long_label || ""}
              </span>
              <span className="p-stats-indicator-value" style={{ fontSize: 20 }}>
                {value}
              </span>
              <NBPDCIndicator props/>
            </div>
            {!props.loading && data.diff && typeof data.diff.value === "number" && (
              <div style={{ margin: 10, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Arrow size={"large"} trend={data.diff.trend || 0} />
              </div>
            )}
          </div>
        </Fragment>
      ) : (
        <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "space-around" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "50%"
            }}
          >
            <div className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s" style={{ fontSize: 20 }}>
              {kpi.long_label || ""}
            </div>
            {/* <span className="p-stats-indicator-value">{value}</span> */}
            {!props.loading && data.value !== null && (data.format === "%" || data.format === "/") ? (
              <div style={{ marginTop: 10, fontSize: 20 }}>{`${toUnit(data.v, data.unit, data.n) || ""} / ${toUnit(
                data.n,
                data.unit
              ) || ""}`}</div>
            ) : null}

              <NBPDCIndicator {...props}/>
          </div>
          <div style={{ width: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {props.loading ? (
              <Spin />
            ) : (
              <Doughnut
                color={"#182BA9"}
                oldestPercentage={0}
                newestPercentage={data.value}
                kpi={kpi}
                fixSafari={true}
              />
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = state => {
  return {
    loading: getTableLoading(state),
    data: getCurrentSummaryData(state),
    kpi: getSummaryKpiSelected(state),
    isComparing: getCompareMode(state)
  };
};

export default connect(
  mapStateToProps,
  {}
)(KpiIndicator);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/KpiIndicator.js